// extracted by mini-css-extract-plugin
module.exports = {"root":"AppSettingBar_root__3Hwvn"};